import React from 'react'
import Sidebar from "../../../../../components/Sidebar";
import PageHeader from "../../../../../components/PageHeader";
import {toast} from "react-toastify";
import moment from "moment";
import { useSearchParams } from "react-router-dom";
import AddressManager from "../../../../../components/Address";
function withParams(Component) {
    return (props) => <Component {...props} params={useSearchParams()} />;
}
class DetailSchool extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: null,
            endDate: null,
            name: "",
            des: "",
            status: "",
        };
    }
    formatMoney(num) {
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }
    renderDiscountType = (statusType) => {
        switch (statusType) {
            case 1:
                return 'Giảm %';
            case 2:
                return 'Giảm giá trị';
            default:
                return '';
        }
    };
    createChargePackage = (listService) => {
        this.setState({showListServicePackage: false});
        this.setState({serviceList: listService});

    }
    componentWillMount() {
        const [searchparams] = this.props.params;
        let schoolId = searchparams.get("id");
    }
    getDetail = () => {
        let payload = {
            id: this.state.programId
        };
    }
    render() {
        let {address, provinceId, districtId, wardId}  = this.state
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="list-school-management" parentClass="system-school-management"/>
                        <div className="mb-4 col-md-10 tab-content">
                            <div className="card col-12">
                                <div className='pt-3 mb-2'>
                                    <PageHeader routerEnable={true} title="Chi tiết trường"/>
                                    <div className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <h2 className='text-center mb-4'>CHI TIẾT TRƯỜNG</h2>
                                        <div className="row">
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tên trường</label>
                                                <label className="label-item">
                                                    {this.state.data?.name}
                                                </label>
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tên viết tắt</label>
                                                <label className="label-item">
                                                    {this.state.data?.des}
                                                </label>
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Loại hình đào tạo</label>
                                                <label className="label-item">
                                                    {this.renderDiscountType(this.state.data?.discountType)}
                                                </label>
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Loại trường</label>
                                                <label className="label-item">
                                                    {this.state.data?.discountValue?this.formatMoney(this.state.data?.discountValue):"0"}
                                                </label>
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Ngày thành lập</label>
                                                <label className="label-item">
                                                    {this.state.data?.startDate ? moment(this.state.data?.startDate).format("DD-MM-YYYY") : ''}
                                                </label>
                                            </div>

                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Khóa học</label>
                                                <label className="label-item">
                                                    {this.state.data?.endDate ? moment(this.state.data?.endDate).format("DD-MM-YYYY") : ''}
                                                </label>
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">SĐT</label>
                                                <label className="label-item">
                                                    {this.state.data?.endDate ? moment(this.state.data?.endDate).format("DD-MM-YYYY") : ''}
                                                </label>
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Email</label>
                                                <label className="label-item">
                                                    {this.state.data?.endDate ? moment(this.state.data?.endDate).format("DD-MM-YYYY") : ''}
                                                </label>
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Fax</label>
                                                <label className="label-item">
                                                    {this.state.data?.endDate ? moment(this.state.data?.endDate).format("DD-MM-YYYY") : ''}
                                                </label>
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Website</label>
                                                <label className="label-item">
                                                    {this.state.data?.endDate ? moment(this.state.data?.endDate).format("DD-MM-YYYY") : ''}
                                                </label>
                                            </div>
                                            <div className="col-12 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">THÔNG TIN ĐỊA CHỈ</label>
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Địa chỉ</label>
                                                <label className="label-item">
                                                    {this.state.data?.endDate ? moment(this.state.data?.endDate).format("DD-MM-YYYY") : ''}
                                                </label>
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Khu vực</label>
                                                <label className="label-item">
                                                    {this.state.data?.endDate ? moment(this.state.data?.endDate).format("DD-MM-YYYY") : ''}
                                                </label>
                                            </div>

                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tỉnh</label>
                                                <label className="label-item">
                                                    {this.state.data?.endDate ? moment(this.state.data?.endDate).format("DD-MM-YYYY") : ''}
                                                </label>
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Thành phố</label>
                                                <label className="label-item">
                                                    {this.state.data?.endDate ? moment(this.state.data?.endDate).format("DD-MM-YYYY") : ''}
                                                </label>
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Quận huyện</label>
                                                <label className="label-item">
                                                    {this.state.data?.endDate ? moment(this.state.data?.endDate).format("DD-MM-YYYY") : ''}
                                                </label>
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Xã phường</label>
                                                <label className="label-item">
                                                    {this.state.data?.endDate ? moment(this.state.data?.endDate).format("DD-MM-YYYY") : ''}
                                                </label>
                                            </div>
                                            <div className="col-12 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">THÔNG TIN HIỆU TRƯỞNG</label>
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tên hiệu trường</label>
                                                <label className="label-item">
                                                    {this.state.data?.endDate ? moment(this.state.data?.endDate).format("DD-MM-YYYY") : ''}
                                                </label>
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">SĐT hiệu trưởng</label>
                                                <label className="label-item">
                                                    {this.state.data?.endDate ? moment(this.state.data?.endDate).format("DD-MM-YYYY") : ''}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

export default withParams(DetailSchool)
